import { Button, Card, Col, Row, Space, Spin, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  AdminMenuLayout,
  InputText,
  SimpleInputSelectMultiple,
} from "../../../../shared/components";
import { BRAND } from "../../../../shared/theme/brand";
import { useListCustomerGroups } from "../../hooks";
import { DataListCustomerGroups } from "../../../../redux/@types";
import { useListCustomerGroupsById } from "../../hooks/listCustomerGroupsById/useListCustomerGroupsById";

const { Title, Text } = Typography;

export const ListCustomerGroupsById = () => {
  const navigate = useNavigate();
  const { isLoading, onSubmitCreateOrUpdate, singleListCustomerGroups } =
    useListCustomerGroups();

  const {
    addCustomers,
    deleteCustomers,
    setValuesSelected,
    userList,
    valuesSelected,
    isLoadingValuesSelected,
  } = useListCustomerGroupsById();

  const { control, handleSubmit: onSubmit } =
    useFormContext<DataListCustomerGroups>();

  return (
    <AdminMenuLayout
      pageDescription="Editar grupo de clientes"
      title="Editar grupo"
    >
      <Card
        bodyStyle={{ padding: "24px", display: "block" }}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        {!singleListCustomerGroups ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div
              style={{
                marginBottom: 24,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f0f0f0",
                paddingBottom: 16,
                gap: 12,
              }}
            >
              <Space align="center" size={12}>
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate("/listCustomerGroups")}
                />
                <div>
                  <h2
                    style={{
                      fontSize: 20,
                      fontWeight: 600,
                      margin: 0,
                      color: "#262626",
                    }}
                  >
                    {`Editar: ${singleListCustomerGroups?.name || `Grupo #${singleListCustomerGroups?.id}`}`}
                  </h2>
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Nombre del grupo y clientes asociados
                  </Text>
                </div>
              </Space>
            </div>

            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Title style={{ marginBottom: 8 }} level={5}>
                  Nombre
                </Title>
                <InputText
                  placeHolder="Ej. Clientes VIP"
                  name="name"
                  control={control}
                />
              </Col>
              <Col span={24}>
                <Title style={{ marginBottom: 8 }} level={5}>
                  Clientes del grupo
                </Title>
                <SimpleInputSelectMultiple
                  showSearch
                  valuesSelect={valuesSelected}
                  onChange={setValuesSelected}
                  label={"Seleccione usuario"}
                  dataOptions={userList || []}
                  clearValue={deleteCustomers}
                />
                <Button
                  type="primary"
                  size="large"
                  onClick={addCustomers}
                  loading={isLoadingValuesSelected}
                  style={{
                    marginTop: 12,
                    borderRadius: 30,
                    fontWeight: 600,
                    height: 40,
                    padding: "0 24px",
                    boxShadow: BRAND.primaryShadow,
                  }}
                >
                  Guardar usuarios
                </Button>
              </Col>
              <Col span={24}>
                <Button
                  type="primary"
                  size="large"
                  block
                  loading={isLoading}
                  onClick={onSubmit(onSubmitCreateOrUpdate)}
                  style={{
                    marginTop: 8,
                    borderRadius: 30,
                    height: 44,
                    fontWeight: 600,
                    boxShadow: BRAND.primaryShadow,
                  }}
                >
                  Actualizar información
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Card>
    </AdminMenuLayout>
  );
};
